<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        class="btn btn--create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea una nuova anagrafica"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>

    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <template v-if="canVerb(resource, 'store')">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea una nuova anagrafica </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAdd"
                  title="Crea una nuova anagrafica"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </template>
            <template v-else>
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </template>
          </div>
        </template>
        <div class="mt-2" id="collapse-1">
          <b-form @submit.prevent="onSearch(filterName)">
            <div class="filter">
              <div class="filter-item" data-cols="3">
                <base-input
                  name="AGFRNAME"
                  v-model="filter.byCustom.title.value"
                  type="text"
                  label="Nominativo"
                  placeholder="Inserisci un nominativo"
                />
                <base-input
                  name="NINO"
                  v-model="filter.byAttribute.NINO"
                  type="text"
                  label="Codice Fiscale"
                  placeholder="Inserisci un codice fiscale"
                />
                <base-input
                  name="CREG"
                  v-model="filter.byAttribute.CREG"
                  type="text"
                  label="Partita IVA"
                  placeholder="Inserisci una partita IVA"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="CLI"
                  label="Cliente"
                  v-model="filter.byAttribute.CLI"
                  :options="opt_sup_cli"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
                <base-select
                  name="SUP"
                  label="Fornitore"
                  v-model="filter.byAttribute.SUP"
                  :options="opt_sup_cli"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
              </div>
              <h3 class="inner-filter-title mt-5">Filtri aggiuntivi</h3>
              <div class="filter-item" data-cols="2">
                <base-input
                  name="PHON"
                  v-model="filter.byAddressBook.PHON"
                  type="text"
                  label="Telefono"
                  placeholder="Inserisci un numero di telefono"
                />
                <base-input
                  name="CELL"
                  v-model="filter.byAddressBook.CELL"
                  type="text"
                  label="Cellulare"
                  placeholder="Inserisci un numero di cellulare"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-input
                  name="FAX"
                  v-model="filter.byAddressBook.FAX"
                  type="text"
                  label="Fax"
                  placeholder="Inserisci un fax"
                />
                <base-input
                  name="MAIL"
                  v-model="filter.byAddressBook.MAIL"
                  type="text"
                  label="Email"
                  placeholder="Inserisci una mail"
                />
              </div>
              <div class="filter-item" data-cols="3">
                <base-select
                  name="PROVINCE"
                  label="Provincia"
                  v-model="filter.province"
                  :options="opt_provinces"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                  @select="onSelectProvince"
                  @remove="onRemoveProvince"
                />
                <base-select
                  name="CITY"
                  label="Comune"
                  v-model="filter.byCorrespondence.CITY"
                  :options="opt_councils"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
                <base-input
                  name="CAP"
                  v-model="filter.byCorrespondence.ZIPC"
                  type="text"
                  label="CAP"
                  maxlength="5"
                  placeholder="Inserisci un CAP"
                />
              </div>
              <div class="filter-item">
                <base-textarea
                  name="ADDR"
                  label="Indirizzo"
                  v-model="filter.byCorrespondence.ADDR"
                  placeholder="Inserisci un indirizzo"
                />
              </div>
              <div v-show="customFilters.length > 0">
                <p>Attributi personalizzati</p>
                <b-row v-for="(element, index) in customFilters" :key="index">
                  <custom-filter
                    v-model="filter.byAttribute[element.key]"
                    :element="element"
                  />
                </b-row>
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca</b-button
              >
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset</b-button
              >
            </div>
          </b-form>
        </div>
      </b-sidebar>
      <table-agency-contacts-accounting
        @edit="onEdit"
        @open_note="openNoteModal"
        @open_document="openDocumentModal"
        @manualFetch="manualFetch"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :filterOn="{
          byRelations: [
            'byCorrespondence',
            'byAddressBook',
            'byDocument',
            'byTask',
          ],
        }"
        :onlyActions="['edit', 'destroy', 'infomodal']"
        @destroy="onDestroy"
        :ref="tableRef"
      ></table-agency-contacts-accounting>
    </div>
    <note-detail-modal :items="notes"></note-detail-modal>
    <document-detail-modal :items="documents"></document-detail-modal>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import TableAgencyContactsAccounting from "@/components/tables/AgencyContactsAccounting";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseTextarea from "@/components/form/BaseTextarea";
import NoteDetailModal from "@/components/modals/noteDetailModal";
import DocumentDetailModal from "@/components/modals/documentDetailModal";
import CustomFilter from "@/components/form/CustomFilter";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { toRelationString /* , toInfoData */ } from "@/utils/transforms";
import { mapGetters, mapActions } from "vuex";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "agency_contact",
      resource: "agency_contacts",
      filterName: "filterAgencyContactAccounting",
      notes: [],
      documents: [],
      activeFilters: {},
      filter: this.initFilter(),
      defaultCountryName: "Italia",
      opt_councils: [],
      opt_provinces: [],
      opt_sup_cli: [
        { text: "Si", value: "Y" },
        { text: "No", value: "N" },
      ],
      opt_agency_contacts_type: [
        { value: "0", text: "Cliente" },
        { value: "1", text: "Fornitore" },
        { value: "2", text: "Fornitore/Cliente" },
      ],
      tableRef: "AgencyContactAccountingTableRef",
      fields: [
        {
          key: "attributables.CNAM",
          value: "attributables.CNAM",
          label: this.getDictionary("attribute_CNAM_value", "agency_contact"),
          sortable: true,
          sortKey: "CNAM",
        },
        {
          key: "attributables.NAME",
          value: "attributables.NAME",
          label: this.getDictionary("attribute_NAME_value", "agency_contact"),
          sortable: true,
          sortKey: "NAME",
        },
        {
          key: "attributables.SURN",
          value: "attributables.SURN",
          label: this.getDictionary("attribute_SURN_value", "agency_contact"),
          sortable: true,
          sortKey: "SURN",
        },
        {
          key: "attributables.NINO",
          value: "attributables.NINO",
          label: this.getDictionary("attribute_NINO_value", "agency_contact"),
          sortable: true,
          sortKey: "NINO",
        },
        {
          key: "attributables.CREG",
          value: "attributables.CREG",
          label: this.getDictionary("attribute_CREG_value", "agency_contact"),
          sortable: true,
          sortKey: "CREG",
        },
        {
          key: "city",
          label: this.getDictionary("city", "agency_contact"),
          value: (item) =>
            toRelationString(
              "correspondences",
              item.correspondences,
              ["CITY"],
              [0],
            ),
        },
        {
          key: "province",
          label: this.getDictionary("province", "agency_contact"),
          value: (item) =>
            toRelationString(
              "correspondences",
              item.correspondences,
              ["VIRTUAL_CITY_PROVINCE"],
              [0],
            ),
        },
        {
          key: "phone",
          label: this.getDictionary("phone", "agency_contact"),
          value: (item) =>
            toRelationString(
              "address_books",
              item.address_books,
              ["PHON"],
              [0],
            ),
        },
        {
          key: "mail",
          label: this.getDictionary("email", "agency_contact"),
          value: (item) =>
            toRelationString(
              "address_books",
              item.address_books,
              ["MAIL"],
              [0],
            ),
        },
        {
          key: "attributables.CLI",
          formatter: (value) => {
            return value === "Y" ? "Si" : "No";
          },
          label: this.getDictionary("attribute_CLI_value", "agency_contact"),
        },
        {
          key: "attributables.SUP",
          formatter: (value) => {
            return value === "Y" ? "Si" : "No";
          },
          label: this.getDictionary("attribute_SUP_value", "agency_contact"),
        },
        {
          key: "document_counter",
          label: this.getDictionary("Documenti"),
          value: (item) => (item.documents ? item.documents.length : 0),
        },
        {
          key: "note_counter",
          label: this.getDictionary("Note"),
          value: (item) =>
            item.tasks
              ? item.tasks.filter((task) => task.task_type.value === 2).length
              : 0,
        },
      ],
    };
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  components: {
    BaseIcon,
    BaseInput,
    TableAgencyContactsAccounting,
    // ButtonGroupTable,
    BaseSelect,
    CustomFilter,
    BaseTextarea,
    NoteDetailModal,
    DocumentDetailModal,
  },
  methods: {
    initFilter() {
      let init = {
        province: null,
        byAttribute: {
          status_agencycontact: 1,
          NAME: null,
          SURN: null,
          CNAM: null,
          NINO: null,
          CREG: null,
          CLI: null,
          SUP: null,
        },
        byCustom: {
          title: {
            value: null,
            likewise: 1,
            filter: "byAttribute",
          },
        },
        byAddressBook: {
          CELL: null,
          PHON: null,
          FAX: null,
          MAIL: null,
        },
        byCorrespondence: {
          CITY: null,
          ADDR: null,
          ZIPC: null,
        },
      };
      return init;
    },
    onEdit(id, item) {
      this.$router.push({
        name: `${this.resource}.edit1`,
        params: { id: `${id}`, item: item },
      });
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create1` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Contatto di contabilità eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSelectProvince(selected) {
      this.opt_councils = this.councils()(selected);
      this.filter.byCorrespondence.CITY = null;
    },
    onRemoveProvince() {
      this.opt_councils = [];
      this.filter.byCorrespondence.CITY = null;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }

      delete this.activeFilters["byAttribute.status_agencycontact"];

      return this.activeFilters;
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    openNoteModal(array) {
      this.notes = array;
      this.$bvModal.show("noteDetailModal");
    },
    openDocumentModal(array) {
      this.documents = array;
      this.$bvModal.show("documentDetailModal");
    },
    ...mapGetters("auth", ["provinces", "councils", "countries"]),
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
  },
  created() {
    /* */
    // debugger;
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("councils"))
      // this.getResources("auth/councils");
      // resources.push({
      //   path: path,
      //   value: "councils",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("provinces"))
      // this.getResources("auth/provinces");
      // resources.push({
      //   path: path,
      //   value: "provinces",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            // const defaultCountryId = this.getCountries().find(
            //   (country) => country.text == this.defaultCountryName
            // ).value;
            // this.opt_provinces = this.getProvinces()(defaultCountryId);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    } else {
      const defaultCountryId = this.countries().find(
        (country) => country.text == this.defaultCountryName,
      ).value;
      this.opt_provinces = this.provinces()(defaultCountryId);
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          const defaultCountryId = this.countries().find(
            (country) => country.text == this.defaultCountryName,
          ).value;
          this.opt_provinces = this.provinces()(defaultCountryId);
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
          // this.$emit("storageLoading", false);
        });
    } else {
      this.isLoading = false;
      // this.$emit("storageLoading", false);
    }
    /* */
    // const defaultCountryId = this.countries().find(
    //   (country) => country.text == this.defaultCountryName
    // ).value;
    // this.opt_provinces = this.provinces()(defaultCountryId);
  },
};
</script>
